import { ReactComponent as PassportShieldGreen } from "common/src/assets/passport-shield-green.svg";
import { ReactComponent as PassportShieldYellow } from "common/src/assets/passport-shield-yellow.svg";
import { ReactComponent as PassportShieldOrange } from "common/src/assets/passport-shield-orange.svg";
import { ReactComponent as PassportShieldWhite } from "common/src/assets/passport-shield-white.svg";
import { jsx as _jsx } from "react/jsx-runtime";
export const PassportShield = props => {
  if (props.color === "green") {
    return /*#__PURE__*/_jsx(PassportShieldGreen, {});
  } else if (props.color === "yellow") {
    return /*#__PURE__*/_jsx(PassportShieldYellow, {});
  } else if (props.color === "orange") {
    return /*#__PURE__*/_jsx(PassportShieldOrange, {});
  } else if (props.color === "white") {
    return /*#__PURE__*/_jsx(PassportShieldWhite, {});
  }
};